exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans|Roboto);", ""]);

// module
exports.push([module.id, ".navbar {\n    /* header-back: */\n    background: #FFFFFF;\n    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.10);\n    z-index: 1000;\n}\n\n.navbar-logo {\n    font-size: 24px;\n    margin-left: 10px;\n    color: #000;\n    font-family: Roboto-Medium;\n    letter-spacing: 2px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main